import React, { forwardRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { ButtonsWrapper, StyledForm } from "./styled";

import { getRequiredField } from "helpers/formValidations";
import { ROUTES_CYCLES_CONFIG, ROUTES_CYCLES_PHRASE } from "./config";

import RegularButton from "components/CustomButtons/Button";
import AutocompleteControlled from "components/AutocompleteControlled/AutocompleteControlled";
import { fetchNewRouteCycle } from "redux/actions/buildings/routeCycles/routeCyclesActions";

const RouteCycleSchema = Yup.object({
  [ROUTES_CYCLES_CONFIG.route.key]: Yup.object().required(
    getRequiredField(ROUTES_CYCLES_CONFIG.route.label)
  ),
  [ROUTES_CYCLES_CONFIG.paymentCycle.key]: Yup.object().required(
    getRequiredField(ROUTES_CYCLES_CONFIG.paymentCycle.label)
  ),
});

export const RouteCyclesForm = forwardRef((props) => {
  const dispatch = useDispatch();
  const { handleClose } = props;
  const { isAddMode, deleteMode, routes, collectPeriods } = useSelector(
    (state) => state.routeCycles
  );

  const handleCloseForm = () => {
    handleClose();
    reset();
  };

  const {
    reset,
    handleSubmit,
    control,
  } = useForm({
    resolver: yupResolver(RouteCycleSchema),
  });

  const onSubmit = React.useCallback(
    (formData) => {
      // You can use the validated data to make your API request here

      const body = {
        idRoute: formData[ROUTES_CYCLES_CONFIG.route.key].id,
        idCollectPeriod: formData[ROUTES_CYCLES_CONFIG.paymentCycle.key].id,
      };

      if (isAddMode) {
        dispatch(fetchNewRouteCycle(body));
      }

      handleCloseForm();
    },
    [reset]
  );

  useEffect(() => {
    if (isAddMode) {
      reset();
    }
  }, [isAddMode]);

  return (
    <>
      <StyledForm component="form" fullWidth onSubmit={handleSubmit(onSubmit)}>
        <AutocompleteControlled
          name={ROUTES_CYCLES_CONFIG.route.key}
          label={ROUTES_CYCLES_CONFIG.route.label}
          options={routes}
          control={control}
        />

        <AutocompleteControlled
          name={ROUTES_CYCLES_CONFIG.paymentCycle.key}
          label={ROUTES_CYCLES_CONFIG.paymentCycle.label}
          options={collectPeriods}
          control={control}
        />

        <ButtonsWrapper>
          <RegularButton
            variant="contained"
            color="danger"
            onClick={handleClose}
          >
            {ROUTES_CYCLES_PHRASE.modal.actions.cancel}
          </RegularButton>
          <RegularButton
            variant="contained"
            type="submit"
            color="info"
          >
            {isAddMode
              ? ROUTES_CYCLES_PHRASE.modal.actions.add
              : deleteMode
              ? ROUTES_CYCLES_PHRASE.modal.actions.delete
              : ROUTES_CYCLES_PHRASE.modal.actions.save}
          </RegularButton>
        </ButtonsWrapper>
      </StyledForm>
    </>
  );
});
